export const withoutZeroEntries = (componentDesignQuantities: { [guid: string]: number }): { [guid: string]: number } =>
  Object.fromEntries(Object.entries(componentDesignQuantities).filter(([, quantity]) => quantity > 0));
